import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
@Component({
  selector: 'app-notifier',
  standalone: true,
  imports: [CommonModule,
],
  templateUrl: './notifier.component.html',
  styleUrls: ['./notifier.component.scss']
})
export class NotifierComponent implements OnInit, OnChanges {

  constructor(private router: Router) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.executeShow.currentValue == true) {
      this.show();
    }
  }
  @Input() executeShow: boolean;
  @Input() message: string;
  @Input() title: string;
  @Input() buttonName: string;
  isVisible: boolean = false;

  show(): void {
    this.isVisible = true;
  }

  hide(): void {
    this.isVisible = false;
  }

  routeTo() {
    this.hide();
    const userId: string = localStorage.getItem("userId");
    this.router.navigate(["/personalProfile"], { queryParams: { 'userId': userId, 'highlightSecondaryEmail': true } });

  }

  // Prevent ESC key from closing the modal
  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
    if (this.isVisible) {
      event.preventDefault();
      event.stopPropagation();
      // Do nothing - modal stays open
    }
  }

}
